import React, { Component } from 'react';
import CargomaticInput from 'components/v2/input';
import { getMarkup, updateMarkup } from 'utils/MarketplaceConfigAPI';
import Container from 'components/v2/container';
import { withTranslation } from 'react-i18next';

class MarketplaceConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markup: null,
      id: null,
    };
  }

  async componentDidMount() {
    try {
      const res = await getMarkup();
      this.setState({ id: res.entity._id, markup: res.entity.markup });
    } catch (e) {
      console.error('Error getting markup', e);
    }
  }

  handleUpdateButton = async () => {
    const { id, markup } = this.state;
    const payload = {
      _id: id,
      markup: markup,
    };
    try {
      const res = await updateMarkup(payload);
    } catch (e) {
      console.log('Error Updating Markup', e);
    }
  };

  render() {
    const { markup } = this.state;
    const { t } = this.props;

    return (
      <Container className="py-8">
        <div className="flex flex-col justify-center mb-4">
          <h2 className="my-0 mb-4">{t('MARKETPLACE_SETTINGS')}</h2>
          <div className="w-96 flex flex-row ">
            <CargomaticInput
              label={t('DEFAULT_MARKUP')}
              placeholder={t('PLEASE_ENTER_MARKUP')}
              value={markup}
              onChange={(value) => {
                this.setState({ markup: value });
              }}
              width={200}
            />
          </div>
          <button
            className="button button-green w-48 mt-4"
            onClick={this.handleUpdateButton}
            disabled={!markup || markup > 1}
          >
            {t('UPDATE_MARKUP')}
          </button>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(MarketplaceConfig);
